import styled from 'styled-components';

export const CertificateVerifyContainer = styled.div`
  margin: 100px auto 100px auto;
  width: 1300px; 

  box-shadown: 0 2px 8px rgba(0,0,0,0.04);
  border-radius: 24px;
  
  background: #fff;
  padding: 40px 20px;
  h1 {
    font-weight: 700;
    font-size: var(--font-large);
    color: #d82e88;
    margin-bottom: 32px;
  }

  @media (max-width: 768px) {
    h1 {
      text-align: center;
      margin-top: -60px;
    }
  }

  .certificate-box {
    background-color: #ffe7f1;
    border-radius: 16px;
    padding: 40px 20px;
    text-align: center;
  }

  .certificate-icon {
    width: 60px;
    margin: 0 auto 24px;
  }

  p {
    font-size: var(--font-medium);
    color: #6b6b6b;
    margin-bottom: 32px;

    span {
      font-weight: 900;
      color: #4a4a4a;
    }
  }

  .certificate-btn {
    display: flex;
    justify-content: center;

    &.disable {
      opacity: 0.3;
    }

    button {
      display: flex;
      align-items: center;
      gap: 8px;
      border: 1px solid #d82e88;
      color: #d82e88;
      background: #fff;
      padding: 12px 24px;
      border-radius: 24px;
      font-weight: 700;
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }

      img {
        width: 20px;
        height: 20px;
      }
    }
  }

  @media (max-width: 768px) {
    width: 90%;
    }
  }
`;
